import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../../../core/consts/redesign/commonRedesign";

export const useStylesNewProposalsModal = makeStyles((theme: Theme) => createStyles({
  headerBox: {
    display: 'flex',
    border: 'none',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '48px 48px 0',
    position: 'sticky',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    zIndex: 1200,
    top: 0,
    left: 0,
    [theme.breakpoints.down(1024)]: {
      padding: '24px 24px 0',
    },
  },

  title: {
    fontWeight: 600,
    fontSize: '41px',
    lineHeight: '45px',
    color: COLORS.black,
    [theme.breakpoints.down(1024)]: {
      fontSize: '24px',
      lineHeight: '25px',
    },
  },

  contentBox: {
    width: '100%',
    padding: '0 48px 8px',
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "24px",
    overflowY: "auto",
    marginBottom: '48px',
    [theme.breakpoints.down(1024)]: {
      padding: '0 24px 4px',
      marginBottom: '24px',
    },
  },
  desc: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '21px',
    color: COLORS.black,

  },
  productBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    gap: '8px',
    [theme.breakpoints.down(1024)]: {
      gap: '16px'
    },
  },
  productTitle: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '21px',
  },
  link: {
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '21px',
    color: COLORS.brand_blue,
    textDecoration: 'none',
    cursor: 'pointer',
    outline: 'none',
    '&:hover': {
      color: COLORS.light_blue,
    },
  },

}))